import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/first-order-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 496.2c132.7 0 240.2-107.5 240.2-240.2s-107.5-240.2-240.2-240.2-240.2 107.5-240.2 240.2 107.5 240.2 240.2 240.2zM248 36.3c121.3 0 219.7 98.4 219.7 219.7s-98.4 219.7-219.7 219.7-219.7-98.4-219.7-219.7 98.4-219.7 219.7-219.7zM248 467.5c116.8 0 211.5-94.7 211.5-211.5s-94.7-211.5-211.5-211.5-211.5 94.7-211.5 211.5 94.7 211.5 211.5 211.5zM434.2 304.5c-3.7 14.2-12.7 36-20.1 48.7l-74.1-35.9 61.5 54.8c-8.9 11.7-25.5 28.4-37.2 37.3l-54.8-61.6 35.9 74.3c-12.6 7.5-34.4 16.5-48.6 20.2l-27.3-78.5 4.8 82.9c-8.6 1.2-17.4 1.8-26.3 1.8s-17.7-0.6-26.3-1.8l4.8-82.5-27.1 78c-14.2-3.7-36-12.8-48.7-20.2l35.9-74.3-54.9 61.6c-11.7-8.9-28.4-25.6-37.2-37.3l61.6-54.9-74.3 35.9c-7.4-12.7-16.4-34.5-20.1-48.7l77.8-27.1-82.2 4.8c-1.2-8.6-1.8-17.3-1.8-26.2 0-9 0.6-17.8 1.8-26.5l82.4 4.8-77.9-27.2c3.7-14.2 12.8-36 20.2-48.7l74.2 35.9-61.5-54.9c8.9-11.7 25.6-28.4 37.3-37.2l54.8 61.5-35.8-74.2c12.7-7.4 34.5-16.4 48.7-20.1l26.9 77.3-4.7-81.6c8.6-1.2 17.4-1.8 26.3-1.8 8.9 0 17.7 0.6 26.3 1.8l-4.7 82.2 27-77.8c17.3 4.5 33.6 11.4 48.6 20.2l-35.8 74.1 54.7-61.5c11.7 8.9 28.4 25.5 37.2 37.2l-61.5 54.8 74.1-35.9c7.4 12.7 16.5 34.4 20.2 48.7l-77.8 27.1 82.2-4.8c1.2 8.7 1.8 17.5 1.8 26.5 0 8.9-0.6 17.6-1.8 26.2l-82.1-4.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/first-order-alt.js
// module id = 828
// module chunks = 0